import { useMemo } from "react";

export function useRole(userRole: number[], role: number[]): boolean {
  const roleMatched = useMemo(() => {
    return role.some((role) => userRole.includes(role));
  }, [role, userRole]);

  return roleMatched;
}
